var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SportsCYSA'),_c('SportsVolleyball'),_c('SportsBasketball'),_c('SportsSoccer'),_c('GetInTouch'),_c('ChildrensStudy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }